import {myOrgs, selectedOrg, switchOrg} from '@/tenants/org.service'
import {Tenant} from '@/tenants/Tenant'
import {h, watch} from 'vue'
import _ from 'lodash'
import {useContaCommand} from '@/commandbar/commandBar.service'

const {registerCommand, unregisterCommandsOfType} = useContaCommand()
const TENANT_SWITCH_COMMAND_TYPE = 'tenant-switch'


watch(myOrgs, () => {
    unregisterCommandsOfType(TENANT_SWITCH_COMMAND_TYPE)
    _(myOrgs.value)
        .sortBy('organizationName')
        .forEach((org: Tenant) => {
            registerCommand({
                type: TENANT_SWITCH_COMMAND_TYPE,
                typeLabel: 'Virksomhet',
                icon: 'i-ph-buildings-fill',
                label: org.organizationName,
                rightContent: h('div', {class: 'flex gap-1'}, [
                    h('kbd', {class: 'kbd kbd-sm', innerHTML: 'ctrl'}),
                    h('kbd', {class: 'kbd kbd-sm', innerHTML: 'shift'}),
                    h('kbd', {class: 'kbd kbd-sm', innerHTML: '▼'}),
                    h('span', {class: 'text-sm', innerHTML: '/'}),
                    h('kbd', {class: 'kbd kbd-sm', innerHTML: '▲'})
                ]),
                key: org.organizationId,
                activate: () => switchOrg(org),
                isActive: () => selectedOrg.value?.id === org.id
            })
        })
})
